import { Emphasis, List, ListItem, Root } from 'mdast'
import { Plugin } from 'unified'
import { visit } from 'unist-util-visit'

/**
 * remarkRehype時のMarkdown形式のリスト変換の処理指定.
 *
 * Markdownのリスト形式をHTMLに変換する際に <li> タグ以下の要素を <p> タグで囲む処理を入れる
 */
export const remarkLists: Plugin = () => tree => {
  visit(tree, 'list', (list: List) => {
    list.spread = true
    list.children.forEach((li: ListItem) => (li.spread = true))
  })
}

/**
 *  MarkdownのCommonMarkでは解釈されないGfmの斜体構文を解釈するためのプラグイン.
 *
 *  unified（CommonMark）の解釈で強調と斜体のマークアップ記法が連続した際に文字として扱うところを、Gfmの解釈でマークアップ記法として扱う.
 */
export function remarkGfmEmphasis() {
  const delimRe = /^([*_])(\S[\s\S]*)$/u
  return (tree: Root) => {
    visit(tree, 'emphasis', (node, index, parent) => {
      if (!parent || index === undefined) return
      if (!node.children || node.children.length === 0) return

      let changed = false
      while (node.children.length > 0) {
        const last = node.children[node.children.length - 1]
        if (last?.type !== 'text') break

        const text = last.value
        const m = text.match(delimRe)
        if (!m) break
        const rest = m[2].replace(/^\s+/, '')
        if (!rest) break
        node.children.pop()
        const emphasisNode: Emphasis = {
          type: 'emphasis',
          children: [{ type: 'text', value: rest }],
        }
        parent.children.splice(index + 1, 0, ...[emphasisNode])
        changed = true
      }
      if (changed && node.children.length === 0) {
        parent.children.splice(index, 1)
      }
    })
  }
}

export function remarkDel() {
  return (tree: any) => {
    visit(tree, 'text', (node, index, parent) => {
      const text = node.value
      const delMatch = /~~(.*?)~~/g

      let match
      let lastIndex = 0
      const children = []

      while ((match = delMatch.exec(text)) !== null) {
        if (match.index > lastIndex) {
          children.push({
            type: 'text',
            value: text.slice(lastIndex, match.index),
          })
        }

        children.push({
          type: 'delete',
          children: [{ type: 'text', value: match[1] }],
        })

        lastIndex = match.index + match[0].length
      }

      if (lastIndex < text.length) {
        children.push({ type: 'text', value: text.slice(lastIndex) })
      }

      if (children.length > 0) {
        parent.children.splice(index, 1, ...children)
      }
    })
  }
}
